import gql from 'graphql-tag';
import { CONDITION_TYPE } from './ConditionType.gql';

export const CONDITION_TYPE_CONNECTION = gql`
  ${CONDITION_TYPE}
  fragment ConditionTypeConnection on ConditionTypeConnection {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...ConditionType
      }
    }
    totalCount
    edgeCount
  }
`;
